import { DefaultButton, getTheme, Header, PrimaryButton, Stack, SystemPanel } from 'buzz_lib_ui';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Unauthorised = _ref => {
  let {
    login,
    passwordReset
  } = _ref;
  const theme = getTheme();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      children: "Buzz"
    }), /*#__PURE__*/_jsx(SystemPanel, {
      iconName: "Airplane",
      iconColour: theme.palette.blue,
      title: "Welcome to Buzz",
      content: /*#__PURE__*/_jsxs(Stack, {
        horizontal: true,
        tokens: {
          childrenGap: 5
        },
        children: [/*#__PURE__*/_jsx(PrimaryButton, {
          onClick: login,
          children: "Log In / Sign Up"
        }), /*#__PURE__*/_jsx(DefaultButton, {
          onClick: passwordReset,
          children: "Forgot Password?"
        })]
      })
    })]
  });
};